import { render, staticRenderFns } from "./activity-review.vue?vue&type=template&id=ab9aadc2&scoped=true&"
import script from "./activity-review.vue?vue&type=script&lang=js&"
export * from "./activity-review.vue?vue&type=script&lang=js&"
import style0 from "./activity-review.vue?vue&type=style&index=0&id=ab9aadc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9aadc2",
  null
  
)

component.options.__file = "activity-review.vue"
export default component.exports